<div class="list-header">
  <div class="row py-2">
    <div class="col-4"></div>
    <div class="col-4">
      <h3 class="pt-2">{{centerLabel}}</h3>
    </div>
    <div class="col-4 text-right">
      <button class="mat-button rightBtn mx-3" mat-border-radius="5px" mat-fab extended *ngIf="rightButtonCondition" (click)="rightBtnClickEvent()">
        <mat-icon>{{rightButtonIcon}}</mat-icon>
        {{rightButtonLabel}}
      </button>
    </div>
  </div>
</div>
<div class="list-body">
  <ng-content></ng-content>
</div>